module.exports = __webpack_public_path__ + "static/media/logo_abbank.e1150e24.svg";